/* @flow */
import Entity from 'lib/Entity';

class PublicDevice extends Entity {
  getMedium() {
    return this.get('type');
  }

  isEnabled() {
    return this.get('enabled');
  }

  isVerified() {
    return this.get('verified');
  }

  getFriendlyName() {
    return this.get('friendly_name');
  }
}

export default PublicDevice;
